import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './styles/main.css'

// --- DEV/FALLBACK MOCK API INTERCEPTOR ---
const setupMockFetch = () => {
  const originalFetch = window.fetch;
  
  if (!localStorage.getItem('mock_wallet_balance')) {
    localStorage.setItem('mock_wallet_balance', '150000');
  }
  if (!localStorage.getItem('mock_wallet_ledger')) {
    localStorage.setItem('mock_wallet_ledger', JSON.stringify([
      {
        id: "l1",
        description: "Komisi Referral - Budi Santoso",
        amount: 50000,
        type: "CREDIT",
        balance_after: 150000,
        created_at: new Date(Date.now() - 3600000 * 2).toISOString()
      },
      {
        id: "l2",
        description: "Komisi Referral - Ani Wijaya",
        amount: 100000,
        type: "CREDIT",
        balance_after: 100000,
        created_at: new Date(Date.now() - 3600000 * 4).toISOString()
      }
    ]));
  }
  if (!localStorage.getItem('mock_wallet_payouts')) {
    localStorage.setItem('mock_wallet_payouts', JSON.stringify([]));
  }

  const handleMockRequest = (urlStr: string, init?: RequestInit): Response => {
    const url = new URL(urlStr, window.location.origin);
    const path = url.pathname;
    const method = init?.method?.toUpperCase() || 'GET';
    console.warn(`[Mock API] Fallback active for: ${method} ${path}`);

    const jsonResponse = (data: any, status = 200) => {
      return new Response(JSON.stringify(data), {
        status,
        headers: { 'Content-Type': 'application/json' }
      });
    };

    if (path.endsWith('/settings/is_registration_open')) {
      return jsonResponse({ value: true });
    }

    if (path.match(/\/api\/events\/[^/]+$/) && method === 'GET') {
      const parts = path.split('/');
      const slug = parts[parts.length - 1];
      return jsonResponse({
        id: "merdeka-event-id",
        slug: slug,
        name: "Merdeka Roll-In 2026",
        status: "OPEN",
        starts_at: "2026-08-16T08:00:00+07:00",
        ends_at: "2026-08-16T12:00:00+07:00",
        raffle_eligibility_threshold: 0,
        config: {
          registration_fields: [
            { name: "name", label: "Nama Lengkap", type: "text", required: true },
            { name: "whatsapp_number", label: "Nomor WhatsApp", type: "text", required: true }
          ],
          communities: [
            { id: "c1", name: "Rameria Riders Club", referral_code: "RAMERIA-CLUB", basecamp_address: "Rameria HQ", postal_code: "12345" }
          ],
          features: {
            enable_quests: true,
            enable_referrals: true,
            enable_ticketing: true
          }
        }
      });
    }

    if (path.match(/\/api\/events\/[^/]+\/registrations$/) && method === 'POST') {
      const body = JSON.parse(init?.body as string || '{}');
      const mockData = {
        registration: {
          id: "mock-reg-id",
          event_id: "merdeka-event-id",
          person_id: "mock-person-id",
          referral_code: "RAMERIA-MEMBER",
          wallet_balance: Number(localStorage.getItem('mock_wallet_balance') || '150000'),
          shirt_size: body.shirt_size || "L",
          created_at: new Date().toISOString()
        },
        person: {
          id: "mock-person-id",
          whatsapp_number: body.whatsapp_number || "62812345678",
          name: body.name || "Rider Rameria"
        },
        token: "mock-session-token"
      };
      localStorage.setItem('mock_registration', JSON.stringify(mockData.registration));
      localStorage.setItem('mock_person', JSON.stringify(mockData.person));
      localStorage.setItem('sentinel_session_token', mockData.token);
      return jsonResponse(mockData);
    }

    if (path.match(/\/api\/events\/[^/]+\/auth\/otp$/) && method === 'POST') {
      return jsonResponse({ success: true });
    }

    if (path.match(/\/api\/events\/[^/]+\/auth\/verify$/) && method === 'POST') {
      const body = JSON.parse(init?.body as string || '{}');
      const storedRegStr = localStorage.getItem('mock_registration');
      const storedPersonStr = localStorage.getItem('mock_person');
      const mockReg = storedRegStr ? JSON.parse(storedRegStr) : {
        id: "mock-reg-id",
        event_id: "merdeka-event-id",
        person_id: "mock-person-id",
        referral_code: "RAMERIA-MEMBER",
        wallet_balance: Number(localStorage.getItem('mock_wallet_balance') || '150000'),
        shirt_size: "L",
        created_at: new Date().toISOString()
      };
      const mockPerson = storedPersonStr ? JSON.parse(storedPersonStr) : {
        id: "mock-person-id",
        whatsapp_number: body.whatsapp_number || "62812345678",
        name: "Rider Rameria"
      };
      const mockData = {
        registration: mockReg,
        person: mockPerson,
        token: "mock-session-token"
      };
      localStorage.setItem('mock_registration', JSON.stringify(mockData.registration));
      localStorage.setItem('mock_person', JSON.stringify(mockData.person));
      localStorage.setItem('sentinel_session_token', mockData.token);
      return jsonResponse(mockData);
    }

    if (path.match(/\/api\/events\/[^/]+\/auth\/me$/) && method === 'GET') {
      const storedRegStr = localStorage.getItem('mock_registration');
      const storedPersonStr = localStorage.getItem('mock_person');
      if (storedRegStr && storedPersonStr) {
        return jsonResponse({
          registration: JSON.parse(storedRegStr),
          person: JSON.parse(storedPersonStr)
        });
      }
      return jsonResponse({ error: 'Unauthorized' }, 401);
    }

    if (path.match(/\/api\/registrations\/[^/]+\/ticket$/) && method === 'GET') {
      const status = localStorage.getItem('mock_payment_status') || 'PENDING';
      return jsonResponse({
        ticket: {
          id: "mock-ticket-id",
          registration_id: "mock-reg-id",
          ticket_tier_id: "mock-tier-id",
          qr_secret: "rameria-ticket-secret-code",
          created_at: new Date().toISOString()
        },
        payments: [
          {
            id: "mock-payment-id",
            registration_id: "mock-reg-id",
            amount: 150000,
            method: "qris",
            status: status,
            qris_string: "0002010102112638240014ID.CO.QRIS.WWW0215ID10202283991230303UMI51190012ID.CO.QRIS.WWW52045311530336054061500005802ID5918RAMERIA EVENT 20266007BANTEN 61051515062070703A016304CA1B",
            created_at: new Date().toISOString(),
            updated_at: new Date().toISOString()
          }
        ]
      });
    }

    if (path.match(/\/api\/events\/[^/]+\/ticket-tiers$/) && method === 'GET') {
      return jsonResponse([
        {
          id: "mock-tier-id",
          event_id: "merdeka-event-id",
          name: "General Admission",
          price: 150000,
          quota: 500,
          sold_count: 42,
          is_active: true,
          starts_at: "2026-07-01T00:00:00Z",
          ends_at: "2026-08-31T23:59:59Z"
        }
      ]);
    }

    if (path.match(/\/api\/registrations\/[^/]+\/payments$/) && method === 'POST') {
      localStorage.setItem('mock_payment_status', 'PENDING');
      return jsonResponse({
        payment: {
          id: "mock-payment-id",
          registration_id: "mock-reg-id",
          amount: 150000,
          method: "qris",
          status: "PENDING",
          qris_string: "0002010102112638240014ID.CO.QRIS.WWW0215ID10202283991230303UMI51190012ID.CO.QRIS.WWW52045311530336054061500005802ID5918RAMERIA EVENT 20266007BANTEN 61051515062070703A016304CA1B",
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString()
        }
      });
    }

    if (path.includes('/webhooks/qris-settle') && method === 'POST') {
      localStorage.setItem('mock_payment_status', 'SUCCESS');
      return jsonResponse({ status: "settled" });
    }

    if (path.match(/\/api\/events\/[^/]+\/quests$/) && method === 'GET') {
      return jsonResponse([
        {
          id: "q1",
          name: "Check-in at Basecamp",
          category: "CHECK_IN",
          points_value: 100,
          completion_status: "APPROVED"
        },
        {
          id: "q2",
          name: "Visit Sponsor Booth",
          category: "SPONSOR",
          points_value: 150,
          completion_status: "PENDING"
        },
        {
          id: "q3",
          name: "Scan Sponsor QR at Bintaro",
          category: "SPONSOR",
          points_value: 200,
          completion_status: null
        }
      ]);
    }

    if (path.match(/\/api\/registrations\/[^/]+\/wallet$/) && method === 'GET') {
      const balance = Number(localStorage.getItem('mock_wallet_balance') || '150000');
      const ledger = JSON.parse(localStorage.getItem('mock_wallet_ledger') || '[]');
      const payouts = JSON.parse(localStorage.getItem('mock_wallet_payouts') || '[]');
      return jsonResponse({ balance, ledger, payouts });
    }

    if (path.match(/\/api\/registrations\/[^/]+\/payout-requests$/) && method === 'POST') {
      const body = JSON.parse(init?.body as string || '{}');
      const currentBalance = Number(localStorage.getItem('mock_wallet_balance') || '150000');
      if (body.amount > currentBalance) {
        return jsonResponse({ error: 'Insufficient balance' }, 400);
      }

      const newBalance = currentBalance - body.amount;
      localStorage.setItem('mock_wallet_balance', String(newBalance));

      const payouts = JSON.parse(localStorage.getItem('mock_wallet_payouts') || '[]');
      const newPayout = {
        id: "payout-req-" + Math.random().toString(36).substr(2, 9),
        amount_requested: body.amount,
        payment_method: body.payment_method,
        status: "REQUESTED",
        requested_at: new Date().toISOString()
      };
      payouts.unshift(newPayout);
      localStorage.setItem('mock_wallet_payouts', JSON.stringify(payouts));

      const ledger = JSON.parse(localStorage.getItem('mock_wallet_ledger') || '[]');
      ledger.unshift({
        id: "l-" + Math.random().toString(36).substr(2, 9),
        description: `Penarikan Dana (${body.payment_method.replace('_', ' ')})`,
        amount: body.amount,
        type: "DEBIT",
        balance_after: newBalance,
        created_at: new Date().toISOString()
      });
      localStorage.setItem('mock_wallet_ledger', JSON.stringify(ledger));

      return jsonResponse({ success: true, payout: newPayout });
    }

    return jsonResponse({ error: 'Mock endpoint not found' }, 404);
  };

  window.fetch = async function(input: RequestInfo | URL, init?: RequestInit) {
    const urlStr = typeof input === 'string' ? input : (input instanceof Request ? input.url : '');
    
    if (urlStr.includes('/api/')) {
      try {
        const response = await originalFetch(input, init);
        if (response.status >= 400 || response.headers.get('content-type')?.includes('text/html')) {
          return handleMockRequest(urlStr, init);
        }
        return response;
      } catch (error) {
        return handleMockRequest(urlStr, init);
      }
    }

    return originalFetch(input, init);
  };
};

if (import.meta.env.DEV) {
  setupMockFetch();
}


const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

app.mount('#app')

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((reg) => console.log('Participant Service Worker registered:', reg.scope))
      .catch((err) => console.error('Participant Service Worker registration failed:', err))
  })
}
